import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { containerAppService } from '@lenovo/micro-frontends-iframe/container-app/container-app.service';
import { TranslateService } from '@ngx-translate/core';
import { LoggerService } from 'src/app/services/logger/logger.service';

@Component({
	selector: 'vtr-page-modern-preload',
	templateUrl: './page-modern-preload.component.html',
	styleUrls: ['./page-modern-preload.component.scss'],
})
export class PageModernPreloadComponent implements OnInit {
	public subApp = containerAppService.getSubAppByName('modern-preload');
	showSkeleton = false;
	title = '';

	constructor(
		public translate: TranslateService,
		private router: Router,
		private logger: LoggerService
	) {}

	ngOnInit(): void {
		this.setTitle();
	}

	async setTitle() {
		this.title = 'Micro front end!';
	}
}
